import React from 'react'
import Imgix from 'react-imgix'

import { NonFullWidthImageComponentProps } from './NonFullWidthImageComponentProps'
import useStyles from './NonFullWidthImageComponent.styles'

const NonFullWidthImageComponent: React.FC<NonFullWidthImageComponentProps> = ({
  image: { src }
}: NonFullWidthImageComponentProps) => {
  const classes = useStyles()

  return (
    <div className={classes.nonFullWidthImageContainer}>
      <Imgix
        src={src}
        className={classes.image}
      />
    </div>
  )
}

export default NonFullWidthImageComponent
